var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.31,
    height: 70.321,
    viewBox: "0 0 70.31 70.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3566",
    "data-name": "Rectangle 3566",
    width: 70.31,
    height: 70.321,
    fill: "#00a4dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10199",
    "data-name": "Group 10199",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10198",
    "data-name": "Group 10198",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32406",
    "data-name": "Path 32406",
    d: "M37.755,70.32a10.861,10.861,0,0,1-7.686-3.142L3.148,40.257A10.937,10.937,0,0,1,.025,31.837L1.183,13.091A12.861,12.861,0,0,1,13.094,1.179L31.841.021a11.072,11.072,0,0,1,8.419,3.123L67.182,30.065A11.8,11.8,0,0,1,66.557,46.7L46.642,66.553a12.56,12.56,0,0,1-8.887,3.767M32.575,5.1h-.467L13.339,6.242A7.787,7.787,0,0,0,6.2,13.376L5.121,32.1a5.791,5.791,0,0,0,1.636,4.566l26.859,26.9a5.912,5.912,0,0,0,4.468,1.658,7.545,7.545,0,0,0,4.949-2.283L62.967,43.029a6.719,6.719,0,0,0,.606-9.417L36.714,6.753A5.714,5.714,0,0,0,32.575,5.1",
    transform: "translate(0 0.002)",
    fill: "#00a4dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32407",
    "data-name": "Path 32407",
    d: "M13.9,22.56a8.649,8.649,0,1,1,.022,0Zm0-12.23a3.57,3.57,0,0,0-2.525,6.115,3.661,3.661,0,0,0,5.052,0,3.579,3.579,0,0,0,0-5.052A3.534,3.534,0,0,0,13.9,10.33",
    transform: "translate(8.994 8.994)",
    fill: "#00a4dd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon4);
export default __webpack_public_path__ + "static/media/merchant-icon4.5c88429af4ce78201936d2385920502f.svg";
export { ForwardRef as ReactComponent };